export default function CardsPanel({ panelData, panelShow, panelExit, cards = [] }) {
  if (!panelData) return null;

  const groups = Array.isArray(cards[0]) ? cards : [cards];

  return (
    <div className={`panel ${panelShow ? "show" : ""} ${panelExit ? "exit" : ""}`}>
      <div className="panel-content">
        <div className="panel-topline">
          <div className="panel-eyebrow">Case Studies</div>
          <div className="panel-title">{panelData.name}</div>
        </div>
        <div className="panel-sub">{panelData.tag}</div>
        <div className="card-grid">
          {groups.map((group, index) => {
            const items = Array.isArray(group) ? group : [group];
            return (
              <div className="card" key={`${panelData.id}-${index}`}>
                <div className="card-title">{items[0] || "Insight"}</div>
                <div className="card-list">
                  {items.map((item, itemIndex) => (
                    <div key={`${panelData.id}-${index}-${itemIndex}`}>{item}</div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
